// 输出跳转链接功能
import router from '../../router'
export default function jumpUrl (classId, jumpType, signUp) {
  switch (jumpType) {
    case 0: // 0 不跳转
      event.preventDefault()
      break
    case 1: // 1 h5连接[资讯]  外部链接 已停用
      router.push({name: 'ArticleDetail', params: {'new_id': classId}})
      break
    case 2: // 2 课程列表【合集id】 暂时用不到
      if (signUp) {
        router.push({name: 'VideoPlay', query: {class_id: classId}})
      } else {
        router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
      }
      break
    case 3: // 3 班级详情【班级id】
      if (signUp) {
        router.push({name: 'VideoPlay', query: {class_id: classId}})
      } else {
        router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
      }
      break
    case 4: // 4 h5连接[活动]  外部链接 已停用
      // router.push({path: classId})
      window.location.href = classId
      break
    case 11: // 易聊
      easyChat()
      break
  }
}
// 默认输出聊天功能
export function easyChat () {
  this.$easyliao(12523, 20523)
  return false
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js